import { useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import ChannelService from "../../services/message/Channel.service";

import { IPostVideo } from "../post/usePost";
import { IMultiLanguageContent, IUserReactionResponse } from "../../commons/interfaces";



export interface IRecordChannel {
    clientId?: string
    tenantCode?: string
    serviceCode?: string
    organizationId?: string
    id?: string
    type?: number
    gene?: string
    name?: string
    replyTo?: string
    communityId?: string
    parentGroup?: string
    accessMode?: number
    description?: string
    referenceId?: string
    avatarImage?: string
    avatarImageUrl?: string
    totalPost?: number
    totalMember?: number
    status?: number
    createTime?: string
    createUser?: string
    updateTime?: string
    updateUser?: string
    isMember?: boolean;
    members?: IMembers[];
}

export interface IMembers {
    userName?: string
    fullName?: string
    avatarUrl?: string
    avatarId?: string
    groupId?: string
    userId?: string
    userType?: number
    role?: number
    id?: string
    status?: number
    createTime?: string
    createUser?: string
    updateTime?: string
    updateUser?: string
}

export interface IRequestGetpaged {
    searchText?: string,
    pageSize?: number,
    pageNumber?: number,
    totalCount?: number,
}

export interface IDataChannel {
    clientId?: string,
    communityId?: string,
    id?: string;
    name?: string,
    description?: string,
    accessMode?: number,
    referenceId?: string,
    avatarImage?: string,
    avatarImageUrl?: string,
    updateTime?: string,
}

export type IErrorChannel = { [key in keyof IDataChannel]?: string };

export interface ICommunityPostDetail {
    threadId?: string
    threadGene?: string
    parentGroupId?: string
    channelId?: string
    reactions?: IReaction[]
    currentReaction?: IUserReactionResponse
    totalComment?: number
    totalReact?: number
    isFollowed?: boolean
    isReacted?: boolean
    postTag?: any
    postVideos?: IPostVideo[]
    postImages?: IPostVideo[]
    owner?: IMembers
    latestComment?: ILatestComment
    type?: number
    tenantCode?: string
    organizationId?: string
    previewImage?: string
    previewImageUrl?: string
    title?: IMultiLanguageContent
    content?: IMultiLanguageContent
    shortDescription?: IMultiLanguageContent
    metaHeader?: string
    searchText?: string
    publishedTime?: string
    eventTime?: string
    isHighlighted?: number
    publishedStatus?: number
    resourceCode?: string
    notification?: number
    id?: string
    status?: number
    createTime?: string
    createUser?: string
    updateTime?: string
    updateUser?: string
}

export interface ILatestComment {
    userName?: string
    fullName?: string
    phoneNumber?: string
    avatarId?: string
    avatarUrl?: string
    postId?: string
    channelId?: string
    threadId?: string
    userId?: string
    userType?: number
    type?: number
    discussionValue?: string
    fileId?: string
    fileUrl?: string
    id?: string
    status?: number
    createTime?: string
    createUser?: string
    updateTime?: string
    updateUser?: string
}

export interface IReaction {
    targetId?: string,
    totalReaction?: number,
    reactionCode?: number | string,
}



const useChannel = () => {
    const Strings = useStrings();

    const {
        clientId,
        onError,
        onSuccess,
        onHideLoading,
        onShowLoading,
    } = useCommonComponentContext();

    const getDataDetailChannel = async (channelId: string, communityId: string) => {
        let newData: IDataChannel = {
            communityId: communityId,
            clientId: clientId,
            name: undefined,
            accessMode: 0,
            description: undefined,
            referenceId: undefined,
            avatarImage: undefined,
            avatarImageUrl: undefined,
        };

        if (!Helpers.isNullOrEmpty(channelId)) {
            try {
                const result = await ChannelService.getDetail(channelId);

                newData = {
                    communityId: result.communityId || communityId,
                    clientId: result.clientId || clientId,
                    id: result.id,
                    name: result.name,
                    accessMode: result.accessMode,
                    description: result.description,
                    referenceId: result.referenceId,
                    avatarImage: result.avatarImage,
                    avatarImageUrl: result.avatarImageUrl,
                    updateTime: result.updateTime,
                };

            } catch (error) {
                onHideLoading();
                const err = Helpers.renderExceptionError(error);
                onError(err);
            }
        }
        return newData;
    };

    const handleDeleteChannel = (data: { channelId: string, onCallBack?: () => void }) => {
        Helpers.showConfirmAlert(
            Strings.CHANNEL.CONFIRM_DELETE,
            async () => {
                try {
                    onShowLoading();

                    await ChannelService.delete(data.channelId);

                    onSuccess(Strings.CHANNEL.DELETE_SUCCESS);

                    await data.onCallBack();

                    onHideLoading();
                } catch (error) {
                    onHideLoading();
                    const err = Helpers.renderExceptionError(error);
                    onError(err);
                }
            }
        )
    }


    return {
        getDataDetailChannel,
        handleDeleteChannel
    };
}


export default useChannel;